//常量
export const STATE = {
  NOT_SUBMIT: 0,
  NO_TIMPROVE: 1,
  SUBMIT: 2,
  FAILURE: 3
}

// tab页签
export const tabConfigList = [
  {
    label: '待提交',
    value: STATE.NOT_SUBMIT+'',
    code: STATE.NOT_SUBMIT,
    num: 0
  },
  {
    label: '待完善',
    value: STATE.NO_TIMPROVE+'',
    code: STATE.NO_TIMPROVE,
    num: 0
  },
  {
    label: '已提交',
    value: STATE.SUBMIT+'',
    code: STATE.SUBMIT,
    num: 0
  },
  {
    label: '已失效',
    value: STATE.FAILURE+'',
    code: STATE.FAILURE,
    num: 0
  }
]

// 搜索表单
export const searchConfig01 = [
  {
    type: 'daterange',
    prop: 'createTime',
    format: 'yyyy-MM-dd HH:mm',
    dateType: 'datetimerange',
    startPlaceholder: '上传时间',
    endPlaceholder: '上传时间',
    width: '200px'
  },
  {
    prop: 'staffName',
    placeholder: '姓名'
  },
  {
    prop: 'staffPhone',
    placeholder: '手机号码'
  }
]
export const searchConfig02 = [
  {
    type: 'daterange',
    prop: 'submitTime',
    format: 'yyyy-MM-dd HH:mm',
    dateType: 'datetimerange',
    startPlaceholder: '提交时间',
    endPlaceholder: '提交时间',
    width: '200px'
  },
  {
    prop: 'staffName',
    placeholder: '姓名'
  },
  {
    prop: 'staffPhone',
    placeholder: '手机号码'
  },
  {
    prop: 'briefId',
    placeholder: '任务书ID'
  },
  {
    prop: 'huishouqudao',
    placeholder: '回收渠道',
    type: 'select',
    options: [
      { value: 0, label: '1' },
      { value: 1, label: '2' },
      { value: 2, label: '3' }
    ]
  }
]

// 表格
export const startColumn01 = [
  {
    label: '任务书ID',
    value: 'briefId'
    // width: 60,
  }
]
export const startColumn02 = [
  {
    label: '姓名',
    value: 'staffName'
    // width: 60,
  },
  {
    label: '手机号码',
    value: 'staffPhone'
    // width: 100
  },
]
export const endColumn01 = [
  {
    label: '上传时间',
    value: 'createTime'
    // width: 60,
  }
]
export const endColumn02 = [
  {
    label: '提交时间',
    value: 'submitTime'
    // width: 100
  }
]
export const endColumn03 = [
  {
    label: '更新时间',
    value: 'submitNoCriminalTime'
    // width: 100
  }
]
export const tableOption = {
  isShowCheckAll: true,
  isShowCheckCount: true,
  column: [
    {
      label: '操作',
      value: 'opt',
      fixed: 'right',
      fixWidth: '156px'
    }
  ]
}